import script from "./StockView.vue?vue&type=script&setup=true&lang=js"
export * from "./StockView.vue?vue&type=script&setup=true&lang=js"

import "./StockView.vue?vue&type=style&index=0&id=e1e34a82&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1e34a82"]])

export default __exports__